export default "__VITE_ASSET__b69T2TLB__"